import * as httpClient from "../../../common/utils/httpClient";

function loadTranslations(locale: string): Promise<Record<string, string>> {
  return httpClient.get(`/locales/${locale}.json`).then((response) => response.json());
}

export { loadTranslations };
